import { updatePriceBreakChart, updatePriceBreakPerItemValue, togglePriceBreakDisplay } from '../pricing/price-break-updater'
import { toggleUomPrice } from '../pricing/price-display'
import { updatePartNumberDisplay, getPriceBreaks } from './putup-helpers'
import { updateTotalPrice } from './price-updater'

export function changePutup(box, element) {
  if (!element) return
  
  const elementClass = element.className
  
  if (elementClass.includes('uom_button')) {
    handleUomButtonClick(box, element)
  } else if (elementClass.includes('quantity')) {
    handleQuantityChange(box, element)
  }
  
  updateTotalPrice(box)
}

function handleUomButtonClick(box, button) {
  clearUomSelections()
  selectUomButton(button)
  updateHiddenFields(box, button)
  updatePriceBreakChart(button)
  
  // Pass quantity input to update per-item price based on current quantity
  const quantityInput = document.getElementById('quantity')
  updatePriceBreakPerItemValue(quantityInput)
  
  togglePriceBreakDisplay(button)
  updatePartNumberDisplay(button)
  
  const priceBreaks = getPriceBreaks(button)
  const firstPrice = priceBreaks[0]?.price || 0
  toggleUomPrice(firstPrice)
}

function handleQuantityChange(box, input) {
  updatePriceBreakPerItemValue(input)
}

function clearUomSelections() {
  document.querySelectorAll('.uom-picker-button.selected').forEach(btn => {
    btn.classList.remove('selected')
    btn.classList.add('unselected')
  })
}

function selectUomButton(button) {
  button.classList.remove('unselected')
  button.classList.add('selected')
}

function updateHiddenFields(box, button) {
  const spoolPutupField = document.getElementById(`spool_putup_${box}`)
  const uomNameField = document.getElementById(`uom_name_${box}`)
  
  if (spoolPutupField) {
    spoolPutupField.value = button.dataset.spoolPutup
  }
  
  if (uomNameField) {
    uomNameField.value = button.dataset.uomValue
  }
}

// Removed - now using shared updateTotalPrice from price-updater.js
